import { Component, OnInit } from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { CreateConciergeActionOnboarding } from '../create-concierge-action-onboarding/create-concierge-action-onboarding';
import { AddMaintenanceItemsOnboarding } from '../add-maintenance-items-onboarding/add-maintenance-items-onboarding';

@Component({
    selector: 'select-maintenance-option-onboarding',
    templateUrl: './select-maintenance-option-onboarding.html',
    styleUrls: ['./select-maintenance-option-onboarding.scss'],
    standalone: false
})
export class SelectMaintenanceOptionOnboarding implements OnInit {

  constructor(
    public onboardingProvider: OnboardingProvider,
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService
  ) {}

  ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Add Assets');
  }

  goToCreateConciergeAction() {
    this.rightSidePanelService.setDialogPageTitle('Add Assets');
    this.rightSidePanelService.navigateTo('onboarding/createConciergeAction', {}, CreateConciergeActionOnboarding);
  }

  goToUploadInventoryList() {
    this.rightSidePanelService.setDialogPageTitle('Add Maintenance Items');
    this.rightSidePanelService.navigateTo('onboarding/addMaintenanceItems', {}, AddMaintenanceItemsOnboarding);
  }

}
